import HeroSection from '@/components/sections/HeroSection';
import VisionSection from '@/components/sections/VisionSection';
import VorherNachherSection from '@/components/sections/VorherNachherSection';
import PaketeSection from '@/components/sections/PaketeSection';
import ErfolgsgeschichtenSection from '@/components/sections/ErfolgsgeschichtenSection';
import KontaktSection from '@/components/sections/KontaktSection';

export default function HomePage() {
  return (
    <div data-testid="home-page">
      <HeroSection />
      <VisionSection />
      <VorherNachherSection />
      <PaketeSection />
      <ErfolgsgeschichtenSection />
      <KontaktSection />
    </div>
  );
}
